import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import WhyWeHoldEventSection from './components/WhyWeHoldEventSection';
import EventProgramSection from './components/EventProgramSection';
import PartnersSection from './components/PartnersSection';
import OrganizersSection from './components/partners/OrganizersSection';
import SponsorsSection from './components/partners/SponsorsSection';
import SuccessPartnersSection from './components/partners/SuccessPartnersSection';
import EventPartnersSection from './components/partners/EventPartnersSection';
import StatesSection from './components/StatesSection';
import CommunityGallery from './components/CommunityGallery';
import EngagementFormsSection from './components/EngagementFormsSection';
import GuestsSection from './components/GuestsSection';
import TimelineSection from './components/TimelineSection';
import ClosingCTASection from './components/ClosingCTASection';
import LanguageSelector from './components/LanguageSelector';
import FooterSection from './components/FooterSection';
import SectionDimensionsDisplay from '../../components/dev/SectionDimensionsDisplay';

const LandingPage = () => {
  const updatePageMetadata = (language) => {
    const titles = {
      ar: 'المؤتمر العام الثاني للاتحاد العام لطلبة سوريا - 31 يناير - 01 فبراير 2026',
      en: 'Second General Conference of the General Union of Syrian Students - January 31 - February 1, 2026',
      tr: 'Suriyeli Öğrenciler Genel Birliği İkinci Genel Konferansı - 31 Ocak - 1 Şubat 2026'
    };
    const title = titles?.[language] || titles?.en;
    document.title = title;

    // Set meta description
    const descriptions = {
      ar: 'محطةٌ مفصلية لترسيخ العمل المؤسسي، نُتوج فيها ختام الدورة الأولى، ونعلن انطلاق الدورة الثانية للاتحاد العام لطلبة سوريا. المؤتمر العام الثاني - 31 يناير - 01 فبراير 2026، جامعة إسطنبول غيليشم.',
      en: 'A pivotal milestone to institutionalize organizational work, where we celebrate the conclusion of the first session and announce the launch of the second session of the General Union of Syrian Students. Second General Conference - January 31 - February 1, 2026, Istanbul Gelişim University.',
      tr: 'Kurumsal çalışmayı pekiştirmek için önemli bir dönüm noktası, Suriyeli Öğrenciler Genel Birliği\'nin birinci oturumunun sona ermesini kutladığımız ve ikinci oturumunun başlangıcını ilan ettiğimiz yer. İkinci Genel Konferans - 31 Ocak - 1 Şubat 2026, İstanbul Gelişim Üniversitesi.'
    };
    const description = descriptions?.[language] || descriptions?.en;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', description);
    
    // Update Twitter Card tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', title);
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) twitterDescription.setAttribute('content', description);
  };

  useEffect(() => {
    // Set page title based on language
    const savedLanguage = localStorage.getItem('memorial-language') || 'ar';
    updatePageMetadata(savedLanguage);

    // Apply initial language settings
    const language = savedLanguage;
    document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'ar';
      updatePageMetadata(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Fixed Language Selector */}
      <div className="fixed top-4 right-4 z-language-selector">
        {/* <LanguageSelector /> */}
      </div>

      {/* Hero Section */}
      <HeroSection />
      
      {/* Organizers Section - NEW */}
      <OrganizersSection />

      {/* Why We Hold Event Section */}
      <WhyWeHoldEventSection />
      
      {/* Timeline Section */}
      <TimelineSection />

      {/* Guests Section */}
      <GuestsSection />

      {/* Event Program Section */}
      <EventProgramSection />
    {/* Event Partners Section */}
      {/* <EventPartnersSection /> */}

      {/* States Section - NEW */}
      {/* <StatesSection /> */}

      {/* Sponsors Section */}
      {/* <SponsorsSection /> */}

      {/* Success Partners Section */}
      <SuccessPartnersSection />

      {/* Partners Section */}
      {/* <PartnersSection /> */}

      {/* Engagement Forms Section */}
      {/* <EngagementFormsSection /> */}

      

      {/* Closing CTA Section */}
      <ClosingCTASection />

      {/* Footer Section */}
      <FooterSection />

      {/* Section Dimensions Display Utility (Dev Tool) */}
      {/* <SectionDimensionsDisplay /> */}
    </div>
  );
};

export default LandingPage;